__turbopack_context__.v({
  "code": "EditableToggleContent-module__e7a7vW__code",
  "codeBlock": "EditableToggleContent-module__e7a7vW__codeBlock",
  "container": "EditableToggleContent-module__e7a7vW__container",
  "editToggle": "EditableToggleContent-module__e7a7vW__editToggle",
});
